import { Modal, Spin } from 'antd';
import moment from 'moment';
import _ from 'lodash';
import React, { useMemo, useState } from 'react';
import { updateCommunityEvent } from '../../../services/communityService';
import CommunityEventForm from './CommunityEventForm';

const EditCommunityEvent = ({ communityEvent, isOpen, onCancelModal }) => {
  const [status, setStatus] = useState({
    type: 'IDLE',
    message: 'Idle mode.'
  });
  const [updatedData, setUpdatedData] = useState(null);
  const [hostIsTrainer, setHostIsTrainer] = useState(false);
  const [trainer, setTrainer] = useState(null);
  const dateFormat = 'dddd, Do MMMM YYYY h:mm:ssA Z';
  const host = useMemo(() => communityEvent?.host, [communityEvent]);
  const cardImg = useMemo(() => communityEvent?.cardImgData, [
    communityEvent
  ]);
  const initialValues = useMemo(() => {
    return {
      ...communityEvent,
      hostFirstName: host?.firstName,
      hostLastName: host?.lastName,
      hostProfileImage: host?.profileImage,
      isActive: communityEvent?.isActive ? 'true' : false,
      startTime: moment(new Date(communityEvent?.startTime), dateFormat),
      endTime: moment(new Date(communityEvent?.endTime), dateFormat),
      mobileImgSrc: cardImg?.mobileImgData?.src,
      desktopImgSrc: cardImg?.desktopImgData?.src
    };
  }, [communityEvent, cardImg, host]);

  const validateDate = (startTime, endTime) => {
    return new Date(startTime).getTime() < new Date(endTime).getTime();
  };

  const getChangedFields = (updatedEvent, originalEvent) => {
    // Calculate diffs in objects
    const diffs = _.differenceWith(
      _.toPairs(updatedEvent),
      _.toPairs(originalEvent),
      _.isEqual
    );

    return diffs.reduce((result, item) => {
      result[item[0]] = item[1];
      return result;
    }, {});
  };

  const onSubmit = async (values) => {
    const payload = {
      eventId: initialValues.eventId,
      title: values.title,
      description: values.description,
      liveLink: values.liveLink,
      recordingLink: values.recordingLink,
      startTime: values.startTime,
      endTime: values.endTime,
      isActive: values.isActive,
      status: values.status,
      type: values.type,
      communities: values.communities,
      host: {
        firstName: trainer?.firstName ?? values.hostFirstName,
        lastName: trainer?.lastName ?? values.hostLastName,
        profileImage: trainer?.profileImage ?? values.hostProfileImage
      },
      cardImgData: {
        alt: values.title,
        mobileImgData: {
          src: values.mobileImgSrc,
          meta: {
            width: 280,
            height: 220
          }
        },
        desktopImgData: {
          src: values.desktopImgSrc,
          meta: {
            width: 280,
            height: 220
          }
        }
      },
      ...(values.liveLocation?.label &&
        values.liveLocation && {
          liveLocation: values.liveLocation
        })
    };
    const formattedFormData = getChangedFields(payload, initialValues);

    if (validateDate(payload.startTime, payload.endTime)) {
      setStatus({ type: 'LOADING', message: 'Is waiting for response' });
      await updateCommunityEvent(formattedFormData, communityEvent._id)
        .then((res) => {
          setStatus({ type: 'SUCCESS', message: 'Successful response' });
          const data = res?.data;
          const host = data?.host;
          const cardImg = data?.cardImgData;
          setUpdatedData({
            ...data,
            hostFirstName: host?.firstName,
            hostLastName: host?.lastName,
            hostProfileImage: host?.profileImage,
            isActive: data?.isActive ? 'true' : false,
            startTime: moment(new Date(data?.startTime), dateFormat),
            endTime: moment(new Date(data?.endTime), dateFormat),
            mobileImgSrc: cardImg?.mobileImgData?.src,
            desktopImgSrc: cardImg?.desktopImgData?.src
          });
        })
        .catch((err) => {
          alert(err);
          setStatus({ type: 'ERROR', message: err?.response?.data });
        });
    } else
      setStatus({
        type: 'ERROR',
        message: 'Start date cannot be after end date!'
      });
  };

  return (
    <div>
      <Modal
        title={`Edit Community Event`}
        visible={isOpen}
        onCancel={() => onCancelModal()}
        footer={null}>
        {status.type === 'LOADING' ? (
          <Spin size="large" />
        ) : (
          <CommunityEventForm
            initialValues={updatedData ? updatedData : initialValues}
            setStatus={setStatus}
            status={status}
            type="Update"
            onSubmit={onSubmit}
            hostIsTrainer={hostIsTrainer}
            setHostIsTrainer={setHostIsTrainer}
            setTrainer={setTrainer}
          />
        )}
      </Modal>
    </div>
  );
};

export default EditCommunityEvent;
